import { gql } from 'apollo-boost'

export const BITKUB_ACTIONS = gql`
query bitkubActions(
  $strategyType: StrategyType!
	$resolution: Resolution!
) {
  bitkubActions(
    strategyType : $strategyType
    resolution : $resolution
  ) {
    __typename
    ... on BitkubActionsOutPut {
      actions {
        symbol
        strategyType
        resolution
        action
        calculateAt
      }
    }
    ... on Error {
      code
      message
    }
  }
}
`

export const ALL_BITKUB_ACTIONS = gql`
query allBitkubActions {
  allBitkubActions {
    __typename
    ... on AllBitkubActionsOutPut {
      actions {
        strategyType
        resolution
        actions {
          symbol
          strategyType
          resolution
          action
          calculateAt
        }
      }
    }
    ... on Error {
      code
      message
    }
  }
}
`